import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Agregar event listeners a las tabs
    this.addTabClickHandlers()

    // Cargar la tab activa al conectar
    const urlParams = new URLSearchParams(window.location.search)
    const tabFromURL = urlParams.get('tab')
    const pageFromURL = urlParams.get('page')
    const queryFromURL = urlParams.get('query')

    const tabToLoad = tabFromURL || "food-dislikes"

    // Construir la URL con todos los parámetros
    let url = `/appointments/${this.element.dataset.appointmentId}/food_preferences_tab?tab=${tabToLoad}`
    if (pageFromURL) {
      url += `&page=${pageFromURL}`
    }
    if (queryFromURL) {
      url += `&query=${encodeURIComponent(queryFromURL)}`
    }

    this.loadTabContent(url, tabToLoad)
  }

  addTabClickHandlers() {
    const tabLinks = document.querySelectorAll('#food-preferences-tabs .nav-link')

    tabLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault()
        const tab = e.target.getAttribute('data-tab')

        // Construir la URL para la nueva tab
        let url = `/appointments/${this.element.dataset.appointmentId}/food_preferences_tab?tab=${tab}`

        this.loadTabContent(url, tab)
        this.updateURL(tab)
      })
    })
  }

  // Método para cargar contenido de una tab específica
  loadTabContent(url, tabName) {
    // Mostrar spinner en la tab correspondiente
    const tabContent = document.getElementById(tabName)
    if (tabContent) {
      tabContent.innerHTML = `
        <div class="text-center py-4">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Cargando...</span>
          </div>
          <p class="mt-2">Cargando contenido...</p>
        </div>
      `
    }

    // Hacer la petición AJAX
    fetch(url)
      .then(response => response.text())
      .then(html => {
        if (tabContent) {
          tabContent.innerHTML = html
        }
        // Cambiar a la tab activa
        this.switchTab(tabName)
      })
      .catch(error => {
        console.error('Error loading tab content:', error)
        if (tabContent) {
          tabContent.innerHTML = '<div class="alert alert-danger">Error al cargar el contenido</div>'
        }
      })
  }

  switchTab(tabId) {
    // Remover active class de todas las tabs y panes
    document.querySelectorAll('#food-preferences-tabs .nav-link').forEach(tab => {
      tab.classList.remove('active')
      tab.setAttribute('aria-selected', 'false')
    })

    document.querySelectorAll('#food-preferences-tab-content .tab-pane').forEach(pane => {
      pane.classList.remove('show', 'active')
    })

    // Agregar active class a la tab clickeada
    const activeTab = document.querySelector(`[data-tab="${tabId}"]`)
    if (activeTab) {
      activeTab.classList.add('active')
      activeTab.setAttribute('aria-selected', 'true')
    }

    // Mostrar el pane correspondiente
    const activePane = document.getElementById(tabId)
    if (activePane) {
      activePane.classList.add('show', 'active')
    }
  }

  updateURL(tab) {
    // Obtener la URL actual y los parámetros de búsqueda
    const url = new URL(window.location)
    const searchParams = url.searchParams

    // Actualizar o agregar el parámetro tab
    searchParams.set('tab', tab)

    // Remover parámetros de paginación cuando se cambia de tab
    searchParams.delete('page')
    searchParams.delete('query')

    // Mantener otros parámetros importantes
    const importantParams = ['doctor_email', 'patient_id', 'step_index']
    importantParams.forEach(param => {
      if (searchParams.has(param)) {
        // Mantener el parámetro como está
      }
    })

    // Actualizar la URL sin recargar la página
    const newURL = url.pathname + '?' + searchParams.toString()
    window.history.pushState({}, '', newURL)
  }

  // Method to clear hash when navigating away
  clearHash() {
    if (window.location.hash) {
      window.history.replaceState(null, null, window.location.pathname + window.location.search)
    }
  }
}
